import React from "react";

const authStorage = () => {
  const token = localStorage.getItem("token");
  const userToken = JSON.parse(token);
  const BEARER = "Bearer " + userToken;

  return BEARER;
};

export default authStorage;
